import React, { createContext, useState, useContext, useEffect } from 'react';
import api from './api';

const CreditContext = createContext();

export const CreditProvider = ({ children }) => {
    const [credits, setCredits] = useState({
        used: 0,
        total: 1600,
        loading: true,
        error: null
    });

    // Simple function to check if user is authenticated
    const isUserAuthenticated = () => {
        const token = localStorage.getItem('token');
        return !!token; // Convert to boolean
    };

    // const fetchCredits = async () => {
    //     // Only fetch credits if the user is authenticated
    //     if (!isUserAuthenticated()) {
    //         console.log('User not authenticated, skipping credit fetch');
    //         return;
    //     }
        
    //     try {
    //         setCredits(prev => ({ ...prev, loading: true, error: null }));
    //         const response = await api.getUserCredits();
    //         setCredits({
    //             used: response.data.used || 0,
    //             total: response.data.total || 1600,
    //             loading: false,
    //             error: null
    //         });
    //     } catch (error) {
    //         console.error('Error fetching credits:', error);
    //         setCredits(prev => ({
    //             ...prev,
    //             loading: false,
    //             error: 'Failed to load credits'
    //         }));
    //     }
    // };

    // Add this function to handle adding credits
    // const addCredits = async (amount = 500) => {
    //     try {
    //         console.log('Adding credits:', amount);
            
    //         // Update credits locally first for immediate feedback
    //         const newCreditsUsed = Math.max(0, credits.used - amount);
    //         const newCredits = {
    //             ...credits,
    //             used: newCreditsUsed,
    //             remaining: credits.total - newCreditsUsed
    //         };
    //         setCredits(newCredits);
            
    //         // Then send the request to the server
    //         const response = await api.addCredits({ amount });
            
    //         console.log('Credits added response:', response.data);
            
    //         // Update with the server response to ensure accuracy
    //         if (response.data) {
    //             setCredits({
    //                 total: response.data.total || 1600,
    //                 used: response.data.used || 0,
    //                 remaining: response.data.remaining || 1600
    //             });
    //         }
    //     } catch (error) {
    //         console.error('Error adding credits:', error);
    //         // Revert the local change if there was an error
    //         fetchCredits();
    //     }
    // };

    // // Fetch credits on initial load, but only if authenticated
    // useEffect(() => {
    //     if (isUserAuthenticated()) {
    //         fetchCredits();
    //     } else {
    //         console.log('User not authenticated, skipping initial credit fetch');
    //     }
    // }, []);

    // Function to update credits after a generation
    // const updateCreditsAfterGeneration = (creditsUsed = 1) => {
    //     setCredits(prev => ({
    //     ...prev,
    //     used: Math.min(prev.used + creditsUsed, prev.total)
    //     }));
    // };

    // // Add this function to refresh credits when a video generation is completed
    // const refreshCreditsAfterVideoGeneration = () => {
    //     console.log('Refreshing credits after video generation');
    //     fetchCredits();
    // };

    return (
        <CreditContext.Provider value={{ 
            // credits, 
            // fetchCredits, 
            // updateCreditsAfterGeneration,
            // addCredits,
            // refreshCreditsAfterVideoGeneration
        }}>
        {children}
        </CreditContext.Provider>
    );
};

export const useCredits = () => useContext(CreditContext);